'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withExternalPropsApp = require('../../withExternalPropsApp');

var _withExternalPropsApp2 = _interopRequireDefault(_withExternalPropsApp);

var _ContentStyled = require('./styles/ContentStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  externalProps: _propTypes2.default.shape({
    fixed: _propTypes2.default.bool
  })
};
var defaultProps = {
  externalProps: {
    fixed: false
  }
};

var _Content = function _Content(props) {
  return _react2.default.createElement(_ContentStyled.ContentStyled, {
    appFixed: props.externalProps.fixed
  }, props.children);
};

_Content.displayName = 'Content';
exports.default = (0, _withExternalPropsApp2.default)(_Content);
_Content.propTypes = propTypes;
_Content.defaultProps = defaultProps;